<div class="rx-procedure-tiles-container">
	<rx-procedure-tiles
		[procedures]="procedureTiles$ | async"
		[selectedProcedureId]="selectedProcedureId$ | async"
		(procedureChanged)="onProcedureSelected($event)"
		[promptOnChange]="false"
		>
	</rx-procedure-tiles>
</div>